<h2>Nexus</h2>

<div *ngIf="isUploading" class="upload-spinner">
  <svg class="spinner" viewBox="0 0 50 50">
    <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
  </svg>
</div>

<div class="tabs-container">
  <div class="tab" [ngClass]="{ active: selectedTab === 'general' }" (click)="switchTab('general')">
    General
  </div>
</div>

<div class="tab-content">
  <div *ngIf="selectedTab === 'general'">
    <div class="toggle-container">
      <span class="label">Default Upload Method</span>
      <div class="toggle-pill-group">
        <div 
          class="toggle-pill" 
          [ngClass]="{'active': nexusUploadDefault === 'dragdrop'}" 
          (click)="toggleSetting('NexusDragDropDefault', 'dragdrop')">
          Drag & Drop
        </div>
        <div 
          class="toggle-pill" 
          [ngClass]="{'active': nexusUploadDefault === 'freetext'}" 
          (click)="toggleSetting('NexusDragDropDefault', 'freetext')">
          Free Text
        </div>
        <div 
          class="toggle-pill" 
          [ngClass]="{'active': nexusUploadDefault === 'link'}" 
          (click)="toggleSetting('NexusDragDropDefault', 'link')">
          Link
        </div>
      </div>
    </div>

    <div class="toggle-container disabled" aria-disabled="true">
      <span class="label">Question Agent</span>
      <div class="toggle-pill-group">
        <div class="toggle-pill">Enabled</div>
        <div class="toggle-pill">Disabled</div>
      </div>
    </div>

    <div class="toggle-container disabled" aria-disabled="true">
      <span class="label">Answer Questions</span>
      <div class="toggle-pill-group">
        <div class="toggle-pill">Enabled</div>
        <div class="toggle-pill">Disabled</div>
      </div>
    </div>

    <div class="toggle-container">
      <span class="label">Show Document Confidence</span>
      <div class="toggle-pill-group">
        <div
          class="toggle-pill"
          [ngClass]="{'active': showDocumentConfidenceEnabled}"
          (click)="toggleSetting('Nexus.ShowDocumentConfidence', 'true')">
          Enabled
        </div>
        <div
          class="toggle-pill"
          [ngClass]="{'active': !showDocumentConfidenceEnabled}"
          (click)="toggleSetting('Nexus.ShowDocumentConfidence', 'false')">
          Disabled
        </div>
      </div>
    </div>

    <div class="input-container disabled" aria-disabled="true">
      <span class="label">Max Output Tokens</span>
      <input 
        type="number"
        [disabled]="true"
        [value]="maxOutputTokens"
        class="number-input"
      />
    </div>

    <div class="input-container disabled" aria-disabled="true">
      <span class="label">Model</span>
      <select
        [disabled]="true"
        [ngModel]="selectedModel"
        class="select-dropdown"
      >
        <option value="gpt4o">GPT-4o</option>
        <option value="gpt4omini">GPT-4o Mini</option>
        <option value="gpt-4-turbo">GPT-4 Turbo</option>
        <option value="gpt-4">GPT-4</option>
        <option value="5mini">GPT-5 Mini</option>
      </select>
    </div>

    <div class="input-container disabled" aria-disabled="true">
      <span class="label">Temperature</span>
      <input
        type="number"
        step="0.01"
        min="0"
        max="2"
        [disabled]="true"
        [value]="temperature"
        class="number-input"
      />
    </div>

  </div>
</div>
